var _excluded = ["title", "text", "image", "link", "button", "customColor", "isImageShow", "openOnClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import { getBackgroundByTextColor } from "../../../utils/getCustomColor";
import isNotEmpty from "../../../utils/isNotEmpty/index";
import TextAtm from "../../atoms/TextAtm";
import AnimateHeightOrg from "../../organisms/AnimateHeightOrg";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import { StyledArrowSvg, StyledMinusSvg, StyledPlusSvg, Wrapper, ContentWrapper, HeaderContainer, IconWrapper, StyledBreakpointVisability, TextContainer, ImageWrapper, HoverImageWrapper, Link, StyledFlexItem, Footer, DesktopButton, StyledMobileButton, largeBreakpointValue } from "./TileLinkMol.styled";
function TileLinkMol(_ref) {
  var title = _ref.title,
    text = _ref.text,
    image = _ref.image,
    link = _ref.link,
    button = _ref.button,
    customColor = _ref.customColor,
    isImageShow = _ref.isImageShow,
    openOnClick = _ref.openOnClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasHover = _useState4[0],
    setHasHover = _useState4[1];
  var backgroundColorValue = customColor && getBackgroundByTextColor(customColor.text) || "backgroundLight";
  var hasImage = isNotEmpty(image);
  var hasImageAndShow = hasImage && isImageShow;
  var hasButton = isNotEmpty(button);
  var hasLink = isNotEmpty(link);
  var hasButtonOrLink = hasLink || hasButton;
  var handleIsOpen = function handleIsOpen() {
    if (openOnClick && !isOpen) {
      openOnClick();
    }
    setIsOpen(function (value) {
      return !value;
    });
  };
  var content = /*#__PURE__*/React.createElement(FlexContainerOrg, {
    direction: "column",
    justifyContent: "space-between"
  }, hasImage ? /*#__PURE__*/React.createElement(StyledBreakpointVisability, {
    from: "small",
    to: largeBreakpointValue
  }, /*#__PURE__*/React.createElement(ImageWrapper, null, image)) : null, /*#__PURE__*/React.createElement(TextContainer, null, text), hasLink || hasButton ? /*#__PURE__*/React.createElement(StyledMobileButton, _extends({}, link, button, {
    isExpanded: true,
    variant: (button === null || button === void 0 ? void 0 : button.variant) || "outlined",
    size: "small",
    color: (button === null || button === void 0 ? void 0 : button.color) || ((customColor === null || customColor === void 0 ? void 0 : customColor.text) === "customLight" ? "white" : "dark"),
    title: (link === null || link === void 0 ? void 0 : link.title) || (button === null || button === void 0 ? void 0 : button.title) || ""
  }), (link === null || link === void 0 ? void 0 : link.text) || (button === null || button === void 0 ? void 0 : button.text)) : null);
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    onMouseEnter: !isImageShow && hasImage ? function () {
      return setHasHover(true);
    } : undefined,
    onMouseLeave: !isImageShow && hasImage ? function () {
      return setHasHover(false);
    } : undefined,
    $backgroundColor: backgroundColorValue,
    $customColor: customColor ? customColor.background : undefined,
    $showImage: hasImageAndShow || hasHover
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColorValue
  }, /*#__PURE__*/React.createElement(ContentWrapper, {
    $showImage: hasImageAndShow || hasHover
  }, /*#__PURE__*/React.createElement(StyledFlexItem, {
    flexGrow: 1,
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(HeaderContainer, {
    onClick: handleIsOpen
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: {
      small: "large3",
      medium: "large3",
      large: "big3",
      huge: "large3"
    },
    htmlTag: "h3"
  }, title), /*#__PURE__*/React.createElement(IconWrapper, null, isOpen ? /*#__PURE__*/React.createElement(StyledMinusSvg, {
    $onColor: backgroundColorValue
  }) : /*#__PURE__*/React.createElement(StyledPlusSvg, {
    $onColor: backgroundColorValue
  }))), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, content), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "large"
  }, /*#__PURE__*/React.createElement(AnimateHeightOrg, {
    isOpen: isOpen
  }, content))), /*#__PURE__*/React.createElement(Footer, {
    $hasArrow: hasLink
  }, hasButton && !hasLink ? /*#__PURE__*/React.createElement(DesktopButton, _extends({}, button, {
    isExpanded: true
  }), button.text) : null, hasLink && !hasButton ? /*#__PURE__*/React.createElement(Link, link, /*#__PURE__*/React.createElement(StyledArrowSvg, {
    $onColor: backgroundColorValue
  })) : null), hasImage && hasButtonOrLink ? /*#__PURE__*/React.createElement(HoverImageWrapper, null, /*#__PURE__*/React.createElement(Link, {
    href: (link === null || link === void 0 ? void 0 : link.href) || (button === null || button === void 0 ? void 0 : button.href) || undefined,
    to: (link === null || link === void 0 ? void 0 : link.to) || (button === null || button === void 0 ? void 0 : button.to) || undefined,
    title: (link === null || link === void 0 ? void 0 : link.title) || (button === null || button === void 0 ? void 0 : button.title) || ""
  }, image)) : null, hasImage && !hasButtonOrLink ? /*#__PURE__*/React.createElement(HoverImageWrapper, null, image) : null)));
}
export default TileLinkMol;